'use strict';

/**
 * Syncs the browser URL with the PLP permalink after load-more updates the grid footer.
 */
function updateUrl() {
	let permalinkUrl = $('.permalink').val();

	if (permalinkUrl) {
		window.history.pushState({}, '', permalinkUrl);
	}
}

/**
 * @returns {string} current URL without its hash, which identifies the results being shown
 */
function getResultsUrl() {
	return window.location.pathname + window.location.search;
}

module.exports = {
	init: function () {
		$('body').on('search:updateDom', function (e, selector) {
			if (selector === '.grid-footer') {
				updateUrl();
			}
		});
	},

	/**
	 * Reloads on back/forward only when the results change. Hash-only navigations also fire
	 * popstate, but must be left to the native anchor scroll.
	 */
	onPopState: function () {
		const nativePushState = window.history.pushState;
		let shownResultsUrl = getResultsUrl();

		window.history.pushState = function (...args) {
			nativePushState.apply(window.history, args);
			shownResultsUrl = getResultsUrl();
		};

		$(window).on('popstate', function () {
			if (getResultsUrl() !== shownResultsUrl) {
				window.location.reload();
			}
		});
	},
};
